import { render, staticRenderFns } from "./buildForm.vue?vue&type=template&id=4122bb32&scoped=true&"
import script from "./buildForm.vue?vue&type=script&lang=ts&"
export * from "./buildForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4122bb32",
  null
  
)

export default component.exports